import { LastName } from '@dreryk/person-name-common-api';

import { commonTranslationKeys, FormContextValues } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

export type LastNameValue = { lastName: string | null };
type LastNameInputProps = Pick<FormContextValues<LastNameValue>, 'register'>;

export const LastNameInput = (props: LastNameInputProps): JSX.Element => {
   const controller = props.register('lastName', {
      required: true,
      maxLength: LastName.MAX_LENGTH,
   });

   return <TextInput testId={'lastName'} label={commonTranslationKeys.lastName} controller={controller} />;
};
